export default () =>
  import(
    /* webpackChunkName: 'coffee/app/enterprise-account' */ './EnterpriseAccount'
  );
